import { useSelector } from "react-redux"

const ADMIN_ROLE_ID = "5l7vZR"

const useIsAdmin = () => {

  const roleId = useSelector(state => state?.auth?.userData?.role?.groupId)
  
  return roleId === ADMIN_ROLE_ID

}

export default useIsAdmin
